import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ErrorMessage from '../../_shared/errormessage/errormessage';
import Loading from '../../_shared/loading/loading.component';

@inject('appStore')
@observer
export class SubmissionHandler extends Component {
    static defaultProps = {
        showLoading: false
    };

    render() {
        const { appStore, children, store, showLoading } = this.props,
            { RestartPriorV2Title, RestartPriorV2Text } = window.HTContent;

        if (appStore.error && appStore.error.code === 404) {
            return <ErrorMessage
                title='Not found'
                text="We could not find your submission. Please click 'start over' to begin again."
            />;
        } else if (appStore.error) {
            return <ErrorMessage
                title='An error occurred'
                text={appStore.error.message}
            />;
        } else if (store && store.error && store.error.code === 404) {
            return <ErrorMessage
                title='Not found'
                text="We could not find your submission. Please click 'start over' to begin again."
            />;
        } else if (store && store.error) {
            return <ErrorMessage
                title='An error occurred'
                text={store.error.message}
            />;
        } else if (appStore.loading) {
            return <Loading />;
        } else if (showLoading && store && store.loading) {
            return <Loading />;
        } else if (appStore && appStore.priorV2Submission) {
            return <ErrorMessage
                title={RestartPriorV2Title}
                text={RestartPriorV2Text}
            />;
        }
        return children;
    }
}

export default SubmissionHandler;
